import { jsx as _jsx } from "react/jsx-runtime";
import { getObjectHash, NodeEdgeMapper } from '@iotv/datamodel-core';
import { useContext, useEffect, useReducer } from 'react';
import { NodeEdgeMapperContext } from '../../../../../../../ContextProviders/NodeEdgeMapperComponentContext';
import { isDeviceEnabledType } from '../../../../../../../data/TypeHelpers';
import { batchGetLatestDCTs } from '../../../EntityGroup/queries/batchGetLatestDCTs';
import { defaultState, EntityGroupControlContext, EntityGroupControlReducer, } from '../../../EntityGroup/Reducers/EntityGroupControlReducer';
import { EntityProgrammeSetControlInternal } from '../EntityProgrammeSetControlInternal';
const debug = process.env.REACT_APP_DEBUG && false;
export const EntityControlState = ({ entity }) => {
    const [state, dispatch] = useReducer(EntityGroupControlReducer, defaultState);
    const { state: nodeEdgeMapperState } = useContext(NodeEdgeMapperContext);
    const Entities = nodeEdgeMapperState.nodeEdgeMapper.getContainedItems().filter(isDeviceEnabledType);
    const entitiesHash = getObjectHash(Object.keys(Entities ?? {}));
    useEffect(() => {
        if (Entities && Object.keys(Entities ?? {}).length > 0) {
            const EntityGroupContext = new NodeEdgeMapper();
            EntityGroupContext.loadItems(Entities);
            const loadAction = { type: 'LoadContext', value: { EntityGroup: null, EntityGroupContext } };
            dispatch(loadAction);
            debug && console.log(`EntityControlState batchGetLatestDCTs`, nodeEdgeMapperState.apexNode);
            batchGetLatestDCTs({
                Entities,
                addDCTs: (entity, dcts) => {
                    const action = { type: 'AddTransactions', value: { entity, dcts } };
                    dispatch(action);
                },
                broadcastScheduleSk: nodeEdgeMapperState.apexNode?.sk,
            });
        }
    }, [entitiesHash]);
    return (_jsx(EntityGroupControlContext.Provider, { value: { state, dispatch }, children: _jsx(EntityProgrammeSetControlInternal, { entity }) }));
};
